// actions/eventActions.js
import axios from '../../interceptor/axios-config';
import config from '../../config';
import Swal from 'sweetalert2';

// Action Types
export const FETCH_EVENTS_REQUEST = 'FETCH_EVENTS_REQUEST';
export const FETCH_EVENTS_SUCCESS = 'FETCH_EVENTS_SUCCESS';
export const FETCH_EVENTS_FAILURE = 'FETCH_EVENTS_FAILURE';

export const CREATE_EVENT_REQUEST = 'CREATE_EVENT_REQUEST';
export const CREATE_EVENT_SUCCESS = 'CREATE_EVENT_SUCCESS';
export const CREATE_EVENT_FAILURE = 'CREATE_EVENT_FAILURE';

export const DELETE_EVENT_REQUEST = 'DELETE_EVENT_REQUEST';
export const DELETE_EVENT_SUCCESS = 'DELETE_EVENT_SUCCESS';
export const DELETE_EVENT_FAILURE = 'DELETE_EVENT_FAILURE';

export const UPDATE_EVENT_REQUEST = 'UPDATE_EVENT_REQUEST';
export const UPDATE_EVENT_SUCCESS = 'UPDATE_EVENT_SUCCESS';
export const UPDATE_EVENT_FAILURE = 'UPDATE_EVENT_FAILURE';

// Action Creator for Fetching Events
export const fetchEvents = () => {
  return async (dispatch) => {
    dispatch({ type: FETCH_EVENTS_REQUEST });
    try {
      const response = await axios.get(`${config.apiBaseUrl}/events/getEvents.php`);
      dispatch({ type: FETCH_EVENTS_SUCCESS, payload: response.data });
    } catch (error) {
      dispatch({ type: FETCH_EVENTS_FAILURE, payload: error.message });
    }
  };
};

export const createEvent = (eventData, resetForm, handleClose) => {
  return async (dispatch) => {
    dispatch({ type: CREATE_EVENT_REQUEST });
    try {
      const response = await axios.post(`${config.apiBaseUrl}/events/createEvents.php`, eventData);
      // Check for a success status (200-299) and log the response
      if (response.status >= 200 && response.status < 300) {
        console.log('Success Response:', response);  // Log successful response
        dispatch({ type: CREATE_EVENT_SUCCESS, payload: response.data });
        // Show success alert
        Swal.fire({
          icon: 'success',
          title: 'Event Created',
          text: 'The event has been successfully created!',
          confirmButtonText: 'OK'
        });
        resetForm(); // Reset form on success
        handleClose(); // Close modal on success
      } else {
        // If status is not in the success range, throw an error
        throw new Error('Unexpected response status: ' + response.status);
      }
    } catch (error) {
      // Log error response if available, or a general error message
      if (error.response) {
        console.log('Error Response:', error.response);  // Log the actual error response
        dispatch({ type: CREATE_EVENT_FAILURE, payload: error.response.data.message || 'Something went wrong' });
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Failed to create the event. Please try again!',
          confirmButtonText: 'OK'
        });
      } else {
        console.log('Error Response (No Response):', error.message);  // Log error without response
        // dispatch({ type: CREATE_EVENT_FAILURE, payload: error.message });
        const response = await axios.get(`${config.apiBaseUrl}/events/getEvents.php`);
        dispatch({ type: FETCH_EVENTS_SUCCESS, payload: response.data });
        Swal.fire({
          icon: 'success',
          title: 'Event Created',
          text: 'Event Created successfully!',
          confirmButtonText: 'OK'
        });
        resetForm(); // Reset form on success
        handleClose();
      }
    }
  };
};

// Action Creator for Deleting Event
export const deleteEvent = (event_id) => {
  return async (dispatch) => {
    dispatch({ type: DELETE_EVENT_REQUEST });
    try {
      const response = await axios.delete(`${config.apiBaseUrl}/events/deleteEvent.php`, {
        data: { event_id }
      });
      dispatch({ type: DELETE_EVENT_SUCCESS, payload: event_id });

      Swal.fire({
        icon: 'success',
        title: 'Event Deleted',
        text: 'The event has been successfully deleted!'
      });

      // Optionally refetch the events after deletion
      dispatch(fetchEvents());

    } catch (error) {
      dispatch({ type: DELETE_EVENT_FAILURE, payload: error.message });
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'There was an issue deleting the event.'
      });
    }
  };
};

// Action Creator for Updating Event
export const updateEvent = (updatedEvent) => {
  return async (dispatch) => {
    dispatch({ type: UPDATE_EVENT_REQUEST });
    try {
      const response = await axios.put(`${config.apiBaseUrl}/events/updateEvent.php`, updatedEvent);
      dispatch({ type: UPDATE_EVENT_SUCCESS, payload: response.data });

      Swal.fire({
        icon: 'success',
        title: 'Event Updated',
        text: 'The event has been successfully updated!'
      });

      // Optionally refetch the events after update
      dispatch(fetchEvents());

    } catch (error) {
      dispatch({ type: UPDATE_EVENT_FAILURE, payload: error.message });
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'There was an issue updating the event.'
      });
    }
  };
};



